import { Grid } from '@mui/material';
import React, { useCallback, useMemo } from 'react';
import { StyledTextField } from 'src/Common/Components/Forms/StyledTextField';

interface Props {
  fields: Record<string, string>;
  onChange: (key: string, value: string) => void;
  disabled?: boolean;
}

export const TemplateFieldForm = ({ fields, onChange, disabled }: Props): React.JSX.Element => {
  const renderFieldInput = useCallback(
    (key: string, value: string) => (
      <StyledTextField
        label={key}
        value={value}
        disabled={disabled}
        onChange={(e) => {
          onChange(key, e.target.value as string);
        }}
      />
    ),
    [onChange, disabled],
  );

  const inputs = useMemo(
    () =>
      Object.entries(fields).map(([key, value], index) => (
        <Grid item xs={'auto'} key={index}>
          {renderFieldInput(key, value)}
        </Grid>
      )),
    [fields, renderFieldInput],
  );

  return (
    <Grid container spacing={2} alignItems={'stretch'} justifyContent={'center'}>
      {inputs}
    </Grid>
  );
};
